import { ROUTES, UI } from "@/constants";
import { ProductType } from "@/types";
import { LinkWithParams } from "./LinkWithParams";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

type ProductOrdersLinkProps = {
  productId: ProductType["productId"];
  productName: ProductType["productName"];
};

export const ProductOrdersLink = ({ productId, productName }: ProductOrdersLinkProps) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <LinkWithParams
          href={ROUTES.products.productOrders(productId)}
          className="text-primary text-sm hover:font-semibold"
        >
          {productName}
        </LinkWithParams>
      </TooltipTrigger>
      <TooltipContent>
        {UI.titles.goTo} {UI.titles.productOrdersTitle(productName)}
      </TooltipContent>
    </Tooltip>
  );
};
